import React, { useState, useEffect } from 'react';
import './Sidebar.css';
import SubscribePopup from './SubscribePopup';

function Sidebar({ activeTab, onTabChange, isOpen, onClose }) {
  const [showSubscribePopup, setShowSubscribePopup] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Only handle clicks when sidebar is open and on mobile
      if (isOpen && window.innerWidth <= 768) {
        // Check if click is outside the sidebar
        const sidebar = document.querySelector('.sidebar');
        if (sidebar && !sidebar.contains(event.target)) {
          onClose();
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  return (
    <>
      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div 
          className={`sidebar-item ${activeTab === 'home' ? 'active' : ''}`}
          onClick={() => {
            onTabChange('home');
            onClose();
          }}
        >
          Home
        </div>
        <div 
          className={`sidebar-item ${activeTab === 'combine' ? 'active' : ''}`}
          onClick={() => {
            onTabChange('combine');
            onClose();
          }}
        >
          Combine
        </div>
        <div 
          className="sidebar-item subscribe-button"
          onClick={() => {
            setShowSubscribePopup(true);
            onClose();
          }}
        >
          Updates erhalten
        </div>
      </div>

      <SubscribePopup 
        open={showSubscribePopup}
        onClose={() => setShowSubscribePopup(false)}
      />
    </>
  );
}

export default Sidebar; 